import { combineReducers } from "redux";

import categoryReducer, {
  initialState as categoryInitialState,
} from "./category";
import speakerReducer, { initialState as speakerInitialState } from "./speaker";
import loginReducer, { initialState as loginInitialState } from "./login";
import staffReducer, { initialState as staffInitialState } from "./staff";
import usersReducer, { initialState as usersInitialState } from "./user";
import eventReducer, { initialState as eventInitialState } from "./event";
import webinarsReducer, { initialState as webinarInitialState } from "./event";
import cmsReducer, { initialState as cmsInitialState } from "./cms";
import newsReducer, { initialState as newsInitialState } from "./news";
import bookingsReducer, {
  initialState as bookingsInitialState,
} from "./bookings";
import attendeesReducer, {
  initialState as attendeesInitialState,
} from "./attendees";
import adminReducer, { initialState as adminInitialState } from "./admin";
import loadingReducer, { initialData as loadingState } from "./loading";

export const initial_state = {
  category: categoryInitialState,
  login: loginInitialState,
  speaker: speakerInitialState,
  staff: staffInitialState,
  users: usersInitialState,
  event: eventInitialState,
  bookings: bookingsInitialState,
  attendees: attendeesInitialState,
  news: newsInitialState,
  cms: cmsInitialState,
  loading: loadingState,
  webinar: webinarInitialState,
  admin: adminInitialState,
};

const rootReducer = combineReducers({
  category: categoryReducer,
  login: loginReducer,
  speaker: speakerReducer,
  staff: staffReducer,
  users: usersReducer,
  event: eventReducer,
  bookings: bookingsReducer,
  attendees: attendeesReducer,
  news: newsReducer,
  cms: cmsReducer,
  loading: loadingReducer,
  webinar: webinarsReducer,
  admin: adminReducer,
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/redux/reducers/index.js